declare var tinymce: any;

import { Component, AfterViewInit, OnDestroy,
         Input, Output, EventEmitter } from '@angular/core';

import { CloudStorageService } from '../../cloud-storage.service';

@Component({
  selector: 'tinymce',
  templateUrl: './tinymce.component.html',
  styleUrls: ['./tinymce.component.scss']
})
export class TinymceComponent implements AfterViewInit,
                                         OnDestroy {
  @Input() elementId: String;
  @Input() content: String;

  @Output() onEditorKeyup = new EventEmitter<any>();

  editor;

  constructor(
    private csService: CloudStorageService
  ) {}

  ngAfterViewInit() {
    tinymce.init({
      selector: '#' + this.elementId,
      branding: false,
      min_height: 450,
      toolbar: 'styleselect | undo redo | bold italic underline strikethrough superscript subscript | forecolor backcolor | alignleft aligncenter alignright alignjustify | image link',
      menubar: false,
      plugins: ['link', 'paste', 'image', 'textcolor'],
      skin_url: '/assets/skins/lightgray',
      automatic_uploads: false,
      file_picker_types: 'image',
      file_picker_callback: (cb, val, meta) => {
        let input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');

        input.onchange = () => {
          let file = input.files[0];

          this.csService.uploadNewsletterFile(file)
                        .then( () => {
                          this.csService.getNewsletterFileUrl(file.name)
                                        .then( url => {
                            cb(url, { title: file.name });
                          });
                        });
        };

        input.click();
      },
      setup: editor => {
        this.editor = editor;
        editor.on('change', () => {
          const content = editor.getContent();
          this.onEditorKeyup.emit(content);
        });
      },
    });
  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/tinymce/tinymce.component.ts